'use client';

import { useMutation } from '@tanstack/react-query';
import type { HTTPError } from 'ky';

import { getUrlToCollectorServiceApi, request } from '@/shared/modules/api';

import { SEND_COLLECTOR_EVENT_QUERY_KEY, SEND_COLLECTOR_EVENT_REQUEST_PATHNAME } from '../constants';

export const useSendCollectorEventMutation = () => {
  return useMutation<void, HTTPError, Record<string, unknown>>({
    mutationKey: SEND_COLLECTOR_EVENT_QUERY_KEY,
    mutationFn: (data) => {
      return request.post(getUrlToCollectorServiceApi() + SEND_COLLECTOR_EVENT_REQUEST_PATHNAME, { json: data }).json();
    },
  });
};
